import { createApiRequest } from '../../utils/apiUtils';

export interface Order {
  id: string;
  activeStoreId: string;
  activeDiningTableId: string;
  cartUniqueId: string;
  menuId: string;
  quantity: number;
  orderType: string;
  status: string;
  createdAt: string;
  updatedAt: string;
  menuName: string;
  menuPrice: number;
  menuImageUrl: string;
  diningTableName: string;
}

export interface Cart {
  cartUniqueId: string;
  diningTableName: string;
  numberOfVisitors: number;
  createdAt: string;
  status: string;
}

export interface FetchOrdersResponse {
  orders: Order[];
  carts: Cart[];
}

export interface MenuOption {
  menuOptionId: string;
  menuOptionName: string;
  menuOptionPrice: number | null;
  menuOptionPriceType: 'ADDITIONAL' | 'DISCOUNT' | null;
}

export interface Order {
  id: string;
  activeStoreId: string;
  activeDiningTableId: string;
  cartUniqueId: string;
  menuId: string;
  menuOption: MenuOption | null;
  quantity: number;
  orderType: string;
  status: string;
  createdAt: string;
  updatedAt: string;
  menuName: string;
  menuPrice: number;
  menuImageUrl: string;
  diningTableName: string;
}

export async function fetchOrders(activeStoreId: string): Promise<FetchOrdersResponse> {
  const response = await createApiRequest<FetchOrdersResponse>(`/active-stores/${activeStoreId}/orders`, {
    method: 'GET',
    requiresAuth: true,
  });

  if (!response) {
    throw new Error('No data received from server');
  }

  return response;
}

export async function acceptOrder(activeStoreId: string, cartId: string): Promise<void> {
  await createApiRequest(`/active-stores/${activeStoreId}/orders/carts/${cartId}/accepted`, {
    method: 'PUT',
    requiresAuth: true,
  });
}

export async function rejectOrder(activeStoreId: string, cartId: string): Promise<void> {
  await createApiRequest(`/active-stores/${activeStoreId}/orders/carts/${cartId}/rejected`, {
    method: 'PUT',
    requiresAuth: true,
  });
}

export async function cancelOrder(activeStoreId: string, orderId: string): Promise<void> {
  await createApiRequest(`/active-stores/${activeStoreId}/orders/${orderId}/cancel`, {
    method: 'PUT',
    requiresAuth: true,
  });
}

export async function restoreOrder(activeStoreId: string, orderId: string): Promise<void> {
  await createApiRequest(`/active-stores/${activeStoreId}/orders/${orderId}/waiting`, {
    method: 'PUT',
    requiresAuth: true,
  });
}
